import Vue from 'vue'
import Vuetify from 'vuetify'
import {
  VApp,
  VBtn,
  VCard,
  VChip,
  VDivider,
  VFooter,
  VForm,
  VIcon,
  VImg,
  VInput,
  VLabel,
  VList,
  VNavigationDrawer,
  VParallax,
  VResponsive,
  VSubheader,
  VTextField,
  VTextarea,
  VToolbar,
} from 'vuetify/lib'
// tslint:disable-next-line
import 'vuetify/src/stylus/app.styl'
import nl from 'vuetify/src/locale/nl'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { nl },
    current: 'nl',
  },
  components: {
    VApp,
    VBtn,
    VCard,
    VChip,
    VDivider,
    VFooter,
    VForm,
    VIcon,
    VImg,
    VInput,
    VLabel,
    VList,
    VNavigationDrawer,
    VParallax,
    VResponsive,
    VSubheader,
    VTextField,
    VTextarea,
    VToolbar,
  },
})
